export class FieldsError extends Error {
  public error: string;
  public fields: Record<string, any>;

  constructor(error: {
    error: string;
    fields?: Record<string, any>;
    message?: string;
  }) {
    super(error.message);
    this.error = error.error;
    this.fields = error.fields || {};
  }
}

export class PolicyToolError extends FieldsError {
  public code: string;
  public policyStatus?: string;

  constructor(error: {
    code: string;
    error: string;
    fields?: Record<string, any>;
    message?: string;
    policyStatus?: string;
  }) {
    super({
      ...error,
      message: error.message || error.fields?.message || error.error,
      fields: error.fields || {},
    });
    this.name = 'PolicyToolError';
    this.code = error.code;
    this.policyStatus = error.policyStatus;
  }
}

export class ForbiddenError extends Error {
  constructor(error) {
    super(error);
  }
}

export class StreamVendorError extends Error {
  constructor(error) {
    super(error);
  }
}
